import { z } from "zod";
// `fingerprintBaseFields` + `BaseFieldValue` (Node `node:crypto`) live in
// `./fingerprint.ts` — kept out of this module so the admin BROWSER bundle,
// which imports the DTOs + zod bodies below, never pulls `node:crypto` (Vite/
// rollup can't externalize it for the browser). Server code (api/worker)
// imports the fingerprint from the package barrel, which re-exports both.
// ---------------------------------------------------------------------------
// Entity kinds
// ---------------------------------------------------------------------------
export const TRANSLATABLE_ENTITY_KINDS = [
    "product",
    "variant",
    "category",
    "brand",
];
export const TranslatableEntityKind = z.enum(TRANSLATABLE_ENTITY_KINDS);
// ---------------------------------------------------------------------------
// PUT bodies (human override)
// All fields optional+nullable; the server normalizes "" → null on write so
// partial saves never blank the storefront.
// ---------------------------------------------------------------------------
const nullableText = z.string().nullable().optional();
export const UpdateProductTranslationBody = z
    .object({
    title: nullableText,
    description: nullableText,
    ingredients: nullableText,
    storage_notes: nullableText,
    spec_extra: z.record(z.string(), z.string()).nullable().optional(),
})
    .strict();
export const UpdateVariantTranslationBody = z
    .object({ title: nullableText, pack_size: nullableText })
    .strict();
export const UpdateTextTranslationBody = z
    .object({ title: nullableText })
    .strict();
